import React from "react";
import isotipoHabitia from "../../../assets/isotipo.png";

// Capitulos XVIII (Sanciones) + XIX (Vigencia). Render condicional por cap.
export default function SancionesPage({ config, pagNum, pagTotal, capRomanoMap }) {
  const cv = config.capitulosVisibles;
  const verSan = !!cv.sanciones;
  const verVig = !!cv.vigencia;
  const secNum = String(pagNum - 2).padStart(2, "0");

  return (
    <section className="page">
      <div className="page-pad">
        <span className="sec-tag">{secNum} · Sanciones y vigencia</span>
        <h2 className="big">Régimen de <em>sanciones.</em></h2>

        {verSan && (
          <div className="art">
            <div className="art-head">
              <div className="art-num">Capítulo {capRomanoMap.sanciones}</div>
              <h3 className="art-title">Sanciones</h3>
            </div>
            <p className="art-lede">
              La transgresión a cualquier disposición, una vez constatada por la Comisión y/o Administración, dará lugar a sanciones notificadas por escrito y graduadas así:
            </p>
            <div className="sanc">
              <div className="sanc-row head">
                <div>Etapa</div>
                <div>Sanción</div>
                <div>Detalle</div>
              </div>
              {config.sanciones.map((s) => (
                <div key={s.id} className="sanc-row">
                  <div className="sanc-step">{s.etapa}</div>
                  <div className="sanc-name">{s.sancion}</div>
                  <div className="sanc-desc">{s.detalle}</div>
                </div>
              ))}
            </div>
            <div className="callout warn">
              <div className="ic">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
                  <path d="M12 3 22 20H2L12 3z" strokeLinejoin="round" />
                  <line x1="12" y1="10" x2="12" y2="14" strokeLinecap="round" />
                  <circle cx="12" cy="17" r="1" fill="currentColor" />
                </svg>
              </div>
              <div>
                <p className="ttl">Plazos de regularización</p>
                <p className="tx">
                  <b>24 hs en situaciones graves</b> (ej. inflamables en cocheras), <b>1 semana en situaciones no graves</b>. Vencido el plazo: aplicación automática de multas.
                </p>
              </div>
            </div>
          </div>
        )}

        {verVig && (
          <div className="art">
            <div className="art-head">
              <div className="art-num">Capítulo {capRomanoMap.vigencia}</div>
              <h3 className="art-title">Vigencia y disposiciones generales</h3>
            </div>
            <p className="art-lede">
              El presente Reglamento entra en vigencia desde el <b>{config.fechaAprobacion}</b>, fecha de su aprobación por la Asamblea de Copropietarios.
            </p>
            <div className="callout">
              <div className="ic">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
                  <circle cx="12" cy="12" r="10" />
                  <line x1="12" y1="11" x2="12" y2="17" strokeLinecap="round" />
                  <circle cx="12" cy="7.5" r="1" fill="currentColor" />
                </svg>
              </div>
              <div>
                <p className="ttl">Marco legal</p>
                <p className="tx">
                  Acciones judiciales conforme arts. 9 y 10 Ley 10.751 (red. Decreto Ley 14.560): <b>multas entre 0,5% y 20% del valor del inmueble</b>, acumulables a gastos comunes.
                </p>
              </div>
            </div>
            <p style={{ fontSize: "9.5pt", lineHeight: 1.55, color: "var(--ink-2)", margin: "10px 0 0" }}>
              Aspectos no previstos serán decididos por Asamblea, Comisión o Administración. Modificaciones por mayoría de Asamblea.
            </p>
          </div>
        )}
      </div>
      <div className="pfooter">
        <div className="br"><img src={isotipoHabitia} alt="" />habitia · Reglamento Interno</div>
        <div className="pn">{String(pagNum).padStart(2, "0")} / {String(pagTotal).padStart(2, "0")}</div>
      </div>
    </section>
  );
}
